import { nameof } from "ts-simple-nameof";
import * as yup from "yup";
import { customNullable } from "..";
import type { VehicleDto, VehiclePriceDto } from "../../dtos";
import { VehicleValidationRuleObject } from "../vehicle";


// zalezi na poradi - v tomto poradi se pak mezi errory preklikava
export const VehicleValidationSchema = yup.object().shape(
    {
        ...VehicleValidationRuleObject,
        [nameof<VehicleDto>(x => x.usage)]: yup.string().optional(),
        [nameof<VehicleDto>(x => x.pocetMistSezeni)]: customNullable(yup.number()).optional(),
        [nameof<VehiclePriceDto>(x => x.price)]: customNullable(yup.number()).required("Zadejte cenu vozdila z faktury"),
    },
    [
        // osetreni cyclic dependency vznikajici pri pouziti when... is... then...
        ["vin", "vin"],
        ["licensePlate", "licensePlate"],
        ["cisloTechnickehoPrukazu", "cisloTechnickehoPrukazu"]
    ]
) as any